export default __webpack_public_path__ + "static/media/map.e863bd46.png";